import { css } from 'styled-components';

export default css`
  padding: 10px 40px 6px;
`;
